import { z } from "zod";

export const schema = z
    .object({
        fila: z.string().min(1, { message: "Fila é obrigatória" }),
        servico_id: z.string().min(1, { message: "Serviço é obrigatório" }),
        tempo_presencial: z.string()
            .min(1, { message: "Tempo de atendimento presencial é obrigatório" })
            .refine((val) => {
                const num = Number(val);
                return !isNaN(num) && num >= 0 && num <= 99;
            }, { message: "Tempo deve estar entre 0 e 99 minutos" }),
        tempo_online: z.string()
            .refine((val) => {
                if (!val || val === "") return true;
                const num = Number(val);
                return !isNaN(num) && num >= 0 && num <= 99;
            }, { message: "Tempo deve estar entre 0 e 99 minutos" }),
    });
